import React from 'react';
import PropTypes from "prop-types";
import './RadioGroup.scss';

import { Root, Item, Indicator } from "@radix-ui/react-radio-group";

class RadioGroup extends React. Component {
    constructor(props, context) {
        super(props, context);
    }

    render() {
        const { defaultValue, value, options } = this.props;

        return <Root
            className="RadioGroupRoot"
            defaultValue={defaultValue}
            aria-label="View density"
            value={value}
            onValueChange={this.props.onValueChange}>
            { options.map(x => {
                return <div key={x.value} style={{ display: "flex", alignItems: "center" }}>
                    <Item className="RadioGroupItem" value={x.value} id={x.value}>
                        <Indicator className="RadioGroupIndicator" />
                    </Item>
                    <label className="Label" htmlFor={`r1-${x.value}`}>{x.label}</label>
                </div>
            }) }
        </Root>;
    }
}

RadioGroup.propTypes = {
    defaultValue: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    onValueChange: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.any.isRequired,
            label: PropTypes.string.isRequired
        })
    ).isRequired
};

export default RadioGroup;